import { IoLogoHtml5, IoLogoCss3 } from 'react-icons/io'
import {
  FaJsSquare,
  FaReact,
  FaNodeJs,
  FaSass,
  FaGitAlt,
  FaGithub,
  FaDocker,
  FaAngular,
  FaFigma,
  FaVuejs,
  FaAws,
} from 'react-icons/fa'
import {
  SiExpress,
  SiMongodb,
  SiTailwindcss,
  SiBootstrap,
  SiFirebase,
  SiTypescript,
  SiCsharp,
  SiDotnet,
  SiMaterialui,
  SiRedux,
  SiStyledcomponents,
  SiChakraui,
  SiMysql,
  SiNextdotjs,
  SiPrisma,
  SiPostgresql,
  SiSqlite,
  SiMicrosoftsqlserver,
  SiNestjs,
  SiExpo,
  SiCypress,
  SiJest,
  SiTestinglibrary,
  SiMocha,
  SiChai,
  SiGraphql,
} from 'react-icons/si'
import sqlLogo from './file-type-sql.svg'

export const icons = [
  {
    label: 'React',
    icon: <FaReact size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'React Native',
    icon: <FaReact size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Next.js',
    icon: <SiNextdotjs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Angular',
    icon: <FaAngular size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Vue.js',
    icon: <FaVuejs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Astro',
    icon: (
      <svg
        width={50}
        height={50}
        className='max-w-[100%]'
        role='img'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M8.358 20.162c-1.186-1.07-1.532-3.316-1.038-4.944.856 1.026 2.043 1.352 3.272 1.535 1.897.283 3.76.177 5.522-.678.202-.098.388-.229.608-.36.166.473.209.95.151 1.437-.14 1.185-.738 2.1-1.688 2.794-.38.277-.782.525-1.175.787-1.205.804-1.531 1.747-1.078 3.119l.044.148a3.158 3.158 0 0 1-1.407-1.188 3.31 3.31 0 0 1-.544-1.815c-.004-.32-.004-.642-.048-.958-.106-.769-.472-1.113-1.161-1.133-.707-.02-1.267.411-1.415 1.09-.012.053-.028.104-.045.165h.002zm-5.961-4.445s3.24-1.575 6.49-1.575l2.451-7.565c.092-.366.36-.614.662-.614.302 0 .57.248.662.614l2.45 7.565c3.85 0 6.491 1.575 6.491 1.575L16.088.727C15.93.285 15.663 0 15.303 0H8.697c-.36 0-.615.285-.784.727l-5.516 14.99z' />
      </svg>
    ),
  },
  {
    label: 'Node.js',
    icon: <FaNodeJs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Express',
    icon: <SiExpress size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Nest.js',
    icon: <SiNestjs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Expo',
    icon: <SiExpo size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'C#',
    icon: <SiCsharp size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: '.NET',
    icon: <SiDotnet size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'JavaScript',
    icon: <FaJsSquare size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'TypeScript',
    icon: <SiTypescript size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'AWS',
    icon: <FaAws size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'MongoDB',
    icon: <SiMongodb size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Redux',
    icon: <SiRedux size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'GraphQL',
    icon: <SiGraphql size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Firebase',
    icon: <SiFirebase size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Prisma',
    icon: <SiPrisma size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'MySQL',
    icon: <SiMysql size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'PostgreSQL',
    icon: <SiPostgresql size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'SQL Server',
    icon: (
      <SiMicrosoftsqlserver size={50} className='w-8 md:w-auto max-w-[100%]' />
    ),
  },
  {
    label: 'SQLite',
    icon: <SiSqlite size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'HTML',
    icon: <IoLogoHtml5 size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'CSS',
    icon: <IoLogoCss3 size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },

  {
    label: 'TailwindCSS',
    icon: <SiTailwindcss size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Sass',
    icon: <FaSass size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Bootstrap',
    icon: <SiBootstrap size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'MUI',
    icon: <SiMaterialui size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'styled components',
    icon: (
      <SiStyledcomponents size={50} className='w-8 md:w-auto max-w-[100%]' />
    ),
  },
  {
    label: 'Chakra UI',
    icon: <SiChakraui size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Docker',
    icon: <FaDocker size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Jest',
    icon: <SiJest size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Testing Library',
    icon: <SiTestinglibrary size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Cypress',
    icon: <SiCypress size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Mocha',
    icon: <SiMocha size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Chai',
    icon: <SiChai size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Git',
    icon: <FaGitAlt size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Github',
    icon: <FaGithub size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Figma',
    icon: <FaFigma size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
]

export const mainIcons = [
  {
    label: 'JavaScript',
    icon: <FaJsSquare size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'TypeScript',
    icon: <SiTypescript size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'C#',
    icon: <SiCsharp size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: '.NET',
    icon: <SiDotnet size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'MongoDB',
    icon: <SiMongodb size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Express',
    icon: <SiExpress size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'React',
    icon: <FaReact size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Node.js',
    icon: <FaNodeJs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'React Native',
    icon: <FaReact size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Next.js',
    icon: <SiNextdotjs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Angular',
    icon: <FaAngular size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Nest.js',
    icon: <SiNestjs size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'SQL',
    icon: <img src={sqlLogo} alt='sql' width={50} height={50} />,
  },
  {
    label: 'Redux',
    icon: <SiRedux size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'GraphQL',
    icon: <SiGraphql size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Firebase',
    icon: <SiFirebase size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Docker',
    icon: <FaDocker size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'HTML',
    icon: <IoLogoHtml5 size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'CSS',
    icon: <IoLogoCss3 size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Figma',
    icon: <FaFigma size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Git',
    icon: <FaGitAlt size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
  {
    label: 'Github',
    icon: <FaGithub size={50} className='w-8 md:w-auto max-w-[100%]' />,
  },
]
